import { ICommercialInfoSchema } from '../repositories/favorites/entities/favorite_entity_for_desktop/CommercialInfoSchema';

export function getIsOfferWithMultiAds(commercialInfo: ICommercialInfoSchema | null | undefined): boolean {
  return !!(commercialInfo && commercialInfo.areaParts && commercialInfo.areaParts.length);
}
